<template>
    <main-dialog :redirect="route" :dialogInfo="usfSingle"></main-dialog>
</template>

<script>
    import Vue from 'vue';
    import { store } from '../../../store';
    import { mapActions } from 'vuex';
    export default {
        metaInfo() {
            return {
                title: this.loading ? '' : 'Полезное',
                titleTemplate: this.loading ? '' : '%s | '+ this.usfSingle.title +''
            }
        },
        data() {
            return {
                date: ''
            }
        },
        props: ['slug','route'],
        computed: {
            usfSingle() {
                return this.$store.getters['usefulStore/item'];
            },
            loading() {
                return this.$store.getters.loading;
            },
        },
        methods:{
            ...mapActions('usefulStore', {
                loadItem: 'loadItem',
            })
        },
        beforeRouteEnter(to, from, next) {
            let s = store.getters['usefulStore/loadedSingleUsf'](to.params.slug);
            if(s === undefined) {
                Vue.http.get('/api/singleArticle.json', {params:{'slug': to.params.slug}})
                    .then(response => response.json(), response => next('*'))
                    .then(data => {
                        next(vm => vm.loadItem(data))
                    });
            } else {
                next(vm => vm.loadItem(s));
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/vue_components/InsidePages/Useful/UsefulSingle.vue